import React from "react";
import {useTranslation} from "react-i18next";

import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import CollectionsMenu from "./CollectionsMenu";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import Stack from "@mui/material/Stack";
import MDTypography from "materialDashboard/components/MDTypography";


const CollectionsTabList = ({
                                collections = [],
                                renderCollection = f => f,
                                onCollectionsUpdate = f => f,
                                emptyCollection,
                                collectionType = "profile",
                                inputDisabled
                            }) => {
    const {t} = useTranslation(['models23']);
    const [selectedIndex, setSelectedIndex] = React.useState("0");
    const selectedIndexValue = parseInt(selectedIndex);

    const handleChange = (event, newIndex) => {
        setSelectedIndex(newIndex);
    };

    const handleNewCollection = () => {
        onCollectionsUpdate([...collections, emptyCollection]);
        setSelectedIndex((collections.length).toString());
    }

    const handleDeleteCollection = () => {
        if (collections.length === 0) {
            return;
        }
        setSelectedIndex(selectedIndexValue > 0 ? (selectedIndexValue - 1).toString() : "0");

        onCollectionsUpdate([...collections.slice(0, selectedIndexValue), ...collections.slice(selectedIndexValue + 1)]);
    }

    return <TabContext value={selectedIndex}>
        <Stack direction="row">
            {
                collections.length > 0 && <TabList onChange={handleChange}
                                                   aria-label="density-profile-tabs">
                    {
                        collections.map((collection, index) => {
                            return <Tab key={index}
                                        label={t(collectionType === 'test' ? 'collectionsTabList.test' : 'collectionsTabList.profile', {index: index + 1})}
                                        value={index.toString()}
                                        sx={{flexGrow: 0, px: 1}}/>
                        })
                    }
                </TabList>
            }
            {
                collections.length === 0 && <MDTypography variant="body2" sx={{color: "text.secondary"}}>
                    {t(collectionType === 'test' ? 'collectionsTabList.noTest' : 'collectionsTabList.noProfile')}
                </MDTypography>
            }
            {!inputDisabled && <CollectionsMenu profileName="density"
                                                onNewCollection={handleNewCollection}
                                                onDeleteCollection={handleDeleteCollection}
                                                collectionType={collectionType}/>
            }
        </Stack>
        {
            collections.map((collection, index) => {
                return <TabPanel key={index} value={index.toString()}>
                    {renderCollection(index)}
                </TabPanel>
            })
        }
    </TabContext>
}


export default CollectionsTabList;